import _JSXStyle from "styled-jsx/style";
import { MenuItem } from '@dhis2-ui/menu';
import { colors } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../locales/index.js';
import { useDebugInfo } from './use-debug-info.js';
export const DebugInfoMenuItem = _ref => {
  let {
    hideProfileMenu,
    showDebugInfoModal
  } = _ref;
  const debugInfo = useDebugInfo();

  const openDebugModal = () => {
    hideProfileMenu();
    showDebugInfoModal();
  };

  const debugInfoLabel = /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["3534786758", [colors.grey700]]]) + " " + "root"
  }, /*#__PURE__*/React.createElement("div", {
    "data-test": "dhis2-ui-headerbar-instanceinfo",
    className: _JSXStyle.dynamic([["3534786758", [colors.grey700]]]) + " " + "instance-info version"
  }, debugInfo.dhis2_version ? i18n.t('DHIS2 {{dhis2Version}}', {
    dhis2Version: debugInfo.dhis2_version
  }) : i18n.t('DHIS2 version unknown')), /*#__PURE__*/React.createElement("div", {
    "data-test": "dhis2-ui-headerbar-appinfo",
    className: _JSXStyle.dynamic([["3534786758", [colors.grey700]]]) + " " + "version"
  }, debugInfo.app_name ? debugInfo.app_version ? "".concat(debugInfo.app_name, " ").concat(debugInfo.app_version) : i18n.t('{{appName}} version unknown', {
    appName: debugInfo.app_name
  }) : debugInfo.app_version ? i18n.t('App {{appVersion}}', {
    appVersion: debugInfo.app_version
  }) : i18n.t('App version unknown')), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3534786758",
    dynamic: [colors.grey700]
  }, [".root.__jsx-style-dynamic-selector{color:".concat(colors.grey700, ";font-style:italic;font-size:14px;line-height:17px;}"), ".instance-info.__jsx-style-dynamic-selector{margin-bottom:4px;}", ".version.__jsx-style-dynamic-selector{white-space:no-wrap;}"]));
  return /*#__PURE__*/React.createElement(MenuItem, {
    dense: true,
    onClick: openDebugModal,
    label: debugInfoLabel,
    dataTest: "dhis2-ui-headerbar-debuginfo"
  });
};
DebugInfoMenuItem.propTypes = {
  hideProfileMenu: PropTypes.func.isRequired,
  showDebugInfoModal: PropTypes.func.isRequired
};